
import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import PaymentSettingsForm from "./PaymentSettingsForm";
import PaymentTransactionsAdmin from "./PaymentTransactionsAdmin";
import { Settings, CreditCard } from "lucide-react";

const PaymentSettingsAdmin = () => {
  const [activeTab, setActiveTab] = useState("settings");

  return (
    <div className="space-y-6">
      <Tabs defaultValue="settings" value={activeTab} onValueChange={setActiveTab}>
        <div className="flex justify-center mb-6">
          <TabsList className="grid grid-cols-2 w-full max-w-md">
            <TabsTrigger value="settings" className="flex items-center gap-2 px-4 py-2.5">
              <Settings className="h-4 w-4" />
              <span>Settings</span>
            </TabsTrigger>
            <TabsTrigger value="transactions" className="flex items-center gap-2 px-4 py-2.5">
              <CreditCard className="h-4 w-4" />
              <span>Transactions</span>
            </TabsTrigger>
          </TabsList>
        </div>
        
        <TabsContent value="settings" className="space-y-4 pt-4 bg-muted/5 rounded-xl p-5 border border-muted/20 shadow-sm">
          <PaymentSettingsForm />
        </TabsContent>
        
        <TabsContent value="transactions" className="space-y-4 pt-4 bg-muted/5 rounded-xl p-5 border border-muted/20 shadow-sm">
          <PaymentTransactionsAdmin />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default PaymentSettingsAdmin;
